import { Component, ChangeDetectionStrategy, signal } from '@angular/core';

import { v4 as uuid } from 'uuid';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

@Component({
  selector: 'fin-continue-reading',
  templateUrl: './continue-reading.component.html',
  styleUrls: ['./continue-reading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ContinueReadingComponent {
  public readonly inputId: string = `continuereading-${uuid()}`;
  public readonly SvgLibraryIcon = SvgLibraryIcon;
  public readonly checked = signal(false);
}
